export const dashboard_en_US: any = {
    user_level_one: 'Principal',
    user_level_two: 'Intermediate',
    user_level_three: 'Advanced',
    user_level_four: 'Expert',
    user_level_five: 'Legend',

    user_profile: 'Profile',
    user_log_out: 'Log out',

    user_profile_change_password_title: 'Change password',
    user_profile_change_password_first_step: 'Old password',
    user_profile_change_password_second_step: 'New password',

    user_profile_change_password_second_step_warning: 'Required elements: 1 lowercase, 1 capital letter, 8 characters, and 1 number.',
    user_profile_security_level_password_one: 'Weak',
    user_profile_security_level_password_two: 'Acceptable',
    user_profile_security_level_password_three: 'Safely',

    user_profile_change_password_third_step: 'Confirm your password',
    user_profile_change_password_save_button: 'Save changes',

    new_order: 'New order',
    orders_title: 'My orders',
    orders_number_order: 'Order number',
    orders_status_title: 'Status',
    orders_status_order_date: 'Date',
    orders_status_reload_button: 'Refresh',
    place_order_load_new_account: 'Add account',
    of: 'of {{ element }}',

    orders_steps_one_title: 'Payment instructions',

    order_number: 'Order number {{ element }}',

    orders_steps_one_we_sent: 'We sent to you {{ element }}: {{ element }} {{ element }}',
    orders_steps_one_you_sent: 'You sent {{ element }}: {{ element }} {{ element }}',
    orders_steps_one_we_will_send: 'We will send {{ element }}: {{ element }} {{ element }}',
    orders_steps_one_you_will_send: 'You will send {{ element }}: {{ element }} {{ element }}',
    orders_steps_one_still_send: 'It still remains to send you {{ element }} {{ element }} {{ element }} {{ element }}',
    orders_steps_one_already_received_button: 'Already received',

    orders_steps_one_from_your_account: 'From your account {{ element }}',
    orders_steps_one_destination_account: 'Destinations account {{ element }}',

    orders_steps_one_payment_number: 'Payment Number {{ element }}',
    orders_steps_one_payment_from: 'From: {{ element }}',

    orders_steps_one_string_one: 'If you have any questions, please contact us immediately. {{ button }}',
    orders_steps_one_string_one_button: 'Go to chat',
    orders_steps_one_string_two: 'Thanks for informing us, We will contact you soon.',
    orders_steps_one_string_three: 'Having trouble with the order? Just reply to the email where you received the instructions.',

    orders_steps_one_canceled_warning:
        'This order has been canceled. You can create a new one or, if you still have doubts, respond to the order email.',
    disabled_orders_view: 'You can`t see this info anymore...',

    orders_steps_two_title: 'Order Progress.',
    orders_steps_two_operator_working: '{{ element }} is operating in this order.',
    orders_steps_two_operator_worked: '{{ element }} operate in this order.',
    orders_steps_two_created_order: 'You create your order {{ element }} {{ element }}',
    orders_steps_two_indentity: 'Before you continue: Documents',

    orders_steps_three_title: 'Order Screenshots',
    orders_steps_three_string_one: 'We are waiting for your payment receipts.',
    orders_steps_three_string_two:
        'You marked that you sent the balance, now we need the receipts of your payments. Remember that they must be from your account.',

    orders_steps_four_title: 'Argentinian invoice',
    orders_steps_four_upload_button: 'Upload tax information',
    orders_steps_four_create_invoices_button: 'Create invoice',
    orders_steps_four_subtitle: 'How will my invoice look like?',
    orders_steps_four_item_info: 'Item description: {{ element }}',
    orders_steps_four_total_amount: 'Total amount: {{ element }} {{ element}}',

    orders_steps_four_upload_board_title: 'Your American tax information',
    orders_steps_four_upload_board_one: 'SSN',
    orders_steps_four_upload_board_two: 'Tax responsability',
    orders_steps_four_upload_board_three: 'Street address',
    orders_steps_four_upload_board_four: 'State',
    orders_steps_four_upload_board_five: 'City',

    place_order_load_new_account_error: '{{ element }} Account required',
    place_order_amount_error_one: 'The amount must be higher than {{ element }}',
    place_order_amount_error_two: 'Review this data.',

    place_order_select_account_pay: 'Select an account *',
    place_order_select_account_receive: 'Select your account or a friend`s account *',
    place_order_pay: 'Pay',

    orders_status_level_zero_title: 'Still unprocessed',
    orders_status_level_zero_info: 'The order requires the manual approval of an operator.',

    orders_status_level_one_title: 'Canceled',
    orders_status_level_one_info: 'The order was closed. This may be because you canceled it or the waiting time has expired.',

    orders_status_level_two_title: 'Omitted',
    orders_status_level_two_info:
        'The order has been discarded. This may be due to exceeding operation limits or having another order in progress.',

    orders_status_level_three_title: 'Processing',
    orders_status_level_three_info: 'The order requires the manual approval of an operator.',

    orders_status_level_four_title: 'Processing',
    orders_status_level_four_info: 'The order is ready and the system is searching for destinations.',

    orders_status_level_five_title: 'Paused',
    orders_status_level_five_info: 'One of the payments sent or received has not yet reached its destination.',

    orders_status_level_six_title: 'Paused',
    orders_status_level_six_info: 'One of our operators is working on the order.',

    orders_status_level_seven_title: 'Waiting for your payment',
    orders_status_level_seven_info: 'Instructions have been generated: you must make the payments and mark "I already sent it".',

    orders_status_level_eight_title: 'Sending',
    orders_status_level_eight_info:
        'The order is in the payment queue: you will receive the total of your balance in one or several parts.',

    orders_status_level_nine_title: 'Validations required',
    orders_status_level_nine_info:
        'For security reasons, documentation supporting the order has been requested, including ID, selfie, or others.',

    order_status_level_ten_title: 'Sent',
    order_status_level_ten_info: 'Done! Your order has been completed',

    orders_status_level_eleven_title: 'Sending',
    orders_status_level_eleven_info: 'The order is almost ready, there are just a few details left.',

    orders_status_level_twelve_title: 'Sending reprogrammed',
    orders_status_level_twelve_info:
        'The payment will be sent in the next order. This is because the payments were consolidated or you have requested to change your destination account.',

    deals_title: 'Offers',
    deals_send_methods_button: 'All methods',
    deals_send_methods_button_bank_transfer: 'Bank transfer {{ element }}',
    deals_cash_send_methods_button: 'All coins available',
    deals_send_methods_title: 'Method',
    deals_benefit: 'Benefit',
    deals_view_more_button: 'View more options',

    referral_program_title: 'Referral',
    referral_program_string: 'Invite and earn!',
    referral_program_question: 'How does this program work?',
    referral_program_warn: 'To unlock this feature, you must have at least one successful order.',

    referral_program_copied_alert: 'Copied',
    referral_program_copied_alert_close: 'Close',
    referral_program_earns: 'My earns',
    referral_program_minimum: 'Minimum withdrawal of 15 dollars.',

    referral_program_withdraw: 'Withdraw',
    referral_program_withdraw_destination: 'Your destination account for withdrawal',
    referral_program_withdraw_amount: 'Amount to withdraw in USD PayPal',

    referral_program_withdraw_amount_selected_less: 'Enter an amount less than or equal to ',
    referral_program_withdraw_amount_selected_required: 'This field is required',
    referral_program_withdraw_amount_selected_higher: 'Enter an amount higher than or equal to ',

    referral_program_withdraw_info_string: 'The minimum amount for withdrawal is 15 USD PayPal or its equivalent.',
    referral_program_withdraw_amount_sending: 'Amount we will send',

    referral_program_board_title:
        '<div class="container-nothing-referral"><h2>This looks lonely...</h2><p>Why you don\'t invite some friends?</p></div>',

    accounts_title: 'Accounts',
    accounts_serch: 'Search...',

    accounts_filters: 'Shorter',
    accounts_filters_select_option_button: 'Select an option',
    accounts_filters_select_options_one: 'Common',
    accounts_filters_select_options_two: 'Favourites',
    accounts_filters_select_options_three: 'Innactives',

    accounts_info_one: 'Address',
    accounts_info_two: 'System',
    accounts_info_three: 'Identification number',
    accounts_info_four: 'Owner name',

    VCC_title: 'Verify PayPal',
    VCC_string:
        'We offer and deliver to your email a virtual card (VCC). This lets you activate your PayPal account without a credit card. It expires 5 years later after getting it. Here are some advantages of having one:',

    VCC_info_li_one: 'Withdraw and receive higher amounts of money monthly than an unverified account.',
    VCC_info_li_two: 'Make online purchases without limits (some online stores only accept sales to users with a verified PayPal account).',
    VCC_info_li_three:
        'Generate more trust in both your buyers and sellers, because if you are already verified, it increases the security of your account.',

    VCC_info_warning:
        'Remember that with your VCC you cannot make purchases or issue payments. They are intended solely for you to verify your PayPal account.',

    VCC_buy_info: 'You are going to acquire your VCC, paying with {{ element }}',
    VCC_buy_third_step: 'We send your VCC',
    VCC_buy_select_country: 'Country of your Paypal account *',

    VCC_make_order: 'Make your order',
    VCC_make_order_cancel: 'Cancel',

    VCC_verified_title: 'VCC Info',
    // prettier-ignore
    VCC_verified_info_p_one:
        'A Virtual Credit Card or VCC is just like a regular credit card, it has a number, expiration date, and verification code. It is a digital version of the physical card we all know, but you don\'t have to wait for it to arrive at your home or pick it up at your bank.',
    VCC_verified_info_p_two:
        'When we get a Virtual Credit Card, we can access many benefits. One of the benefits is being able to verify a PayPal account.',
    VCC_verified_info_p_three: 'At Saldoar, we give you VCCs that is valid for 3 to 5 years, so you can verify your PayPal account.',

    VCC_verified_question: 'What are the benefits of a verified PayPal account?',
    VCC_verified_li_one: 'Withdraw and receive higher amounts of money monthly than an unverified account.',
    VCC_verified_li_two: 'Buy in online stores that only accept selling their products to users with a verified PayPal account.',
    VCC_verified_li_three: 'Having a verified account can make people trust you more when buying and selling.',
    // prettier-ignore
    VCC_verified_li_four:
        'PayPal usually holds payments if they don\'t trust your account, having a verified account can make payments release faster.',
    VCC_verified_li_five: 'Having a verified account can reduce the chances of your account being limited.',

    info_one:
        '<div class="container-nothing-transactions"><h2>Welcome {{element}}!</h2><p>Ready to start exchanging your digital money?<br>Create a new order right now!</p></div>',
    info_two:
        '<div class="container-nothing-accounts"><h2>You don\'t have anything here yet.</h2><p>Start by placing an order to see your accounts.</p></div>',
    create_order_button: 'Create a new order',

    private_help_center_title: 'Help Center',

    account_adress_title: 'Adress',
    account_name_title: 'Name',
    account_holder_title: 'Holder',

    account_edit_button: 'Edit',
    account_delete_button: 'Delete'
};
